// Contact Plan trigger step that references an AI Criteria code
export class AiCriteriaUsageDto {
    messageCodeStepId: number;
    criteriaCode: string;
    contactPlanId: number;
    contactPlanTitle: string;
    triggerId: number;
    triggerTitle: string;

    constructor(init: any) {
        this.messageCodeStepId = init.MessageCodeStepID;
        this.criteriaCode = init.CriteriaCode;
        this.contactPlanId = init.ContactPlanID;
        this.contactPlanTitle = init.ContactPlanTitle;
        this.triggerId = init.TriggerID;
        this.triggerTitle = init.TriggerTitle;
    }
}
